import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Button from './Button.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxButton',
  props: {
    checked: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Button, {
    checked: _ctx.checked,
    disabled: _ctx.disabled,
    type: "checkbox"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["checked", "disabled"]))
}
}

})